/**
 * The overlay hotkeys as Settings shows and records them (2026-10-18). The
 * desktop app checks and registers them (desktop/src/hotkeys.js); this only
 * turns a key press into Electron's accelerator format and back into text.
 */

/** A keydown -> "Control+Alt+M", or null for a lone modifier or a key we do
 *  not offer. Uses `code`, not `key`: on a Mac, Option changes the character. */
export function acceleratorFromEvent(e) {
  const code = String(e?.code || "");
  let key = null;
  if (/^Key[A-Z]$/.test(code)) key = code.slice(3);
  else if (/^Digit[0-9]$/.test(code)) key = code.slice(5);
  else if (/^F([1-9]|1[0-2])$/.test(code)) key = code;
  if (!key) return null;
  const mods = [];
  if (e.ctrlKey) mods.push("Control");
  if (e.altKey) mods.push("Alt");
  if (e.shiftKey) mods.push("Shift");
  if (e.metaKey) mods.push("Command");
  if (!mods.length && !key.startsWith("F")) return null;
  return [...mods, key].join("+");
}

/** "Control+Alt+M" -> "Ctrl+Alt+M", as pilots write it. */
export function displayAccelerator(accel) {
  if (!accel) return "None";
  return String(accel).replace(/\bControl\b/g, "Ctrl").replace(/\bCommand\b/g, "Cmd");
}

export const HOTKEY_LABELS = {
  toggle: "Hide or show the overlay",
  move: "Move it: drag, then press Done (or the keys again)",
  metar: "Show or hide the METAR row",
};
